import styled from "styled-components";

const StyledLabel = styled.div`
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors["black/40"]};
  margin-bottom: 1rem;
`;

export default StyledLabel;
